export default __webpack_public_path__ + "static/media/IBMPlexSans-BoldItalic-Latin1.597509ab.woff2";